import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DrawBar from '../DrawBar/DrawBar';
import BottomBar from '../BottomBar/BottomBar';

const useNetworkStatus = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);
  return online;
};

const Layout = () => {
  const online = useNetworkStatus();

  return (
    <>
      {!online && (
        <div className="offline-banner" role="alert">
          ⚠️ Vous êtes hors-ligne. Certaines fonctionnalités peuvent être limitées.
        </div>
      )}
      <DrawBar />
      <Outlet />
      <BottomBar />
    </>
  );
};

export default Layout;